import { animateScroll } from 'react-scroll';
import { isMobile, isTablet } from 'utilities/browser';

const Scroll = {
    transition(element, position, percentage = 1, timeout = 0, offsetCorrection = 0) {
        const mobile = isMobile() ? isMobile() : false;
        const tablet = isTablet() ? isTablet() : false;
        const mobileOrTablet = mobile || tablet;
        setTimeout(() => {
            // setTimeout is necessary because some delays in render components
            const bodyRect = document.body.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();
            const innerHeight =
                window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const headerElement = document.getElementById('stepsHeader');
            if (!headerElement) return;
            const headerHeight = headerElement.offsetHeight;
            let offset;
            if (position === 'top' || mobileOrTablet) {
                offset = elementRect.top - bodyRect.top - headerHeight;
            } else {
                offset = elementRect.top - bodyRect.top - innerHeight / 2 + element.clientHeight / 2;
            }

            if (position === 'middle' && !mobileOrTablet) {
                offset = (elementRect.top - bodyRect.top - headerHeight) / 2;
            }

            if (position === 'percentage') {
                offset = (elementRect.top - bodyRect.top - headerHeight) * percentage;
            }

            animateScroll.scrollTo(offset + offsetCorrection, { duration: 500 });
        }, timeout);
    },

    offset(num) {
        const mobile = isMobile() ? isMobile() : false;
        const tablet = isTablet() ? isTablet() : false;
        const mobileOrTablet = mobile || tablet;
        setTimeout(() => {
            const headerElement = document.getElementById('stepsHeader');
            const headerHeight = headerElement.offsetHeight;
            const finalPosition = mobileOrTablet ? num - 100 : num; // correct position if mobile or tablet
            const offset = finalPosition - headerHeight;
            animateScroll.scrollTo(offset, { duration: 500 });
        }, 300);
    },
};

module.exports = Scroll;
